/* eslint-disable no-const-assign */
<template>
  <div class="wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-app-container-detail-body content">
        <div class="page-title">
          {{ $t("page.retrievePassword.changePassword") }}
        </div>
        <el-divider></el-divider>
        <el-form
          :model="fromData"
          :rules="rules"
          ref="ruleForm"
          :validate-on-rule-change="false"
          class="ccui-form"
        >
          <el-form-item
            :label="$t('page.retrievePassword.oldPassword')"
            prop="oldPassword"
          >
            <el-col :span="8">
              <el-input
                show-password
                v-model.trim="fromData.oldPassword"
                :placeholder="$t('page.retrievePassword.pleaseOldPassword')"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$t('page.retrievePassword.newPassword')"
            prop="newPassword"
            class="item-err2"
          >
            <el-col :span="8">
              <el-input
                maxlength="16"
                minlength="8"
                show-password
                v-model.trim="fromData.newPassword"
                :placeholder="$t('page.retrievePassword.pleaseNewPassword')"
              ></el-input>
              <span class="ccui-ml-10">
                {{ $t("page.retrievePassword.hintContent6") }}
              </span>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$t('page.retrievePassword.confirmPassword')"
            prop="confirmPassWord"
            class="item-err3"
          >
            <el-col :span="8">
              <el-input
                show-password
                v-model.trim="fromData.confirmPassWord"
                :placeholder="$t('page.retrievePassword.pleaseConfirmPassword')"
              ></el-input>
            </el-col>
          </el-form-item>

          <el-form-item size="large" style="margin-left: 20%;;margin-top:20px;">
            <el-button
              type="primary"
              v-preventReClick
              @click="onSubmit('ruleForm')"
              >{{ $t("page.retrievePassword.ascertain") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
import { updateSupPsw } from "@/app/shop/api/shopping";
export default {
  name: "editPassword",
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      language: Cookies.get("language"),
      currBreadCrumb: [
        {
          title: this.$t("page.retrievePassword.changePassword")
        }
      ],
      fromData: {
        oldPassword: "",
        newPassword: "",
        confirmPassWord: "",
        reqOpenId: ""
      },
      userName: "",
      rules: {
        oldPassword: [
          {
            required: true,
            // max: 100,
            message: this.$t("page.retrievePassword.pleaseOldPassword"),
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("page.retrievePassword.pleaseNewPassword"),
            trigger: "blur"
          },
          // {min:6,max:8,message:window.$t('page.retrievePassword.hintContent7')},
          {
            pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}/,
            message: window.$t("page.retrievePassword.hintContent6"),
            trigger: "blur"
          }
        ],
        confirmPassWord: [
          {
            required: true,
            // max: 100,
            message: this.$t("page.retrievePassword.pleaseConfirmPassword"),
            trigger: "blur"
          }
        ]
      },
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL)
    };
  },
  activated() {
    this.userName = JSON.parse(localStorage.getItem("userInfo")).loginId;
  },
  deactivated() {},
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.fromData.confirmPassWord != this.fromData.newPassword) {
            this.$message({
              message: this.$t("page.content.passValid"),
              type: "warning",
              offset: document.documentElement.clientHeight / 2 - 21
            });
            return false;
          }
          if (this.fromData.oldPassword == this.fromData.newPassword) {
            this.$message({
              message: this.$t("page.content.passValid1"),
              type: "warning",
              offset: document.documentElement.clientHeight / 2 - 21
            });
            return false;
          }
          updateSupPsw({
            oldPassword: this.fromData.oldPassword,
            newPassword: this.fromData.newPassword,
            reqOpenId: JSON.parse(localStorage.getItem("userInfo")).openId,
            userName: this.userName
          }).then(res => {
            if (res.data.code == "0") {
              this.$confirm(
                this.$t("page.retrievePassword.confirmTitle6"),
                this.$t("page.retrievePassword.confirmHint"),
                {
                  confirmButtonText: this.$t("page.retrievePassword.ascertain"),
                  showCancelButton: false,
                  type: "success"
                }
              )
                .then(res => {
                  sessionStorage.clear();
                  localStorage.clear();
                  Cookies.remove("access_token");
                  Cookies.remove("refresh_token");
                  // window.location.href =
                  //   this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
                  //   "?redirectUrl=" +
                  //   this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
                  if (this.baseUrl.indexOf("dev01") != -1) {
                    window.location.href =
                      "http://dev01-mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://dev01-sp.iccec.cn";
                  } else if (this.baseUrl.indexOf("test01") != -1) {
                    window.location.href =
                      "http://test01-mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://test01-sp.iccec.cn";
                  } else if (this.baseUrl.indexOf("uat01") != -1) {
                    window.location.href =
                      "https://uat01-mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://uat01-sp.iccec.cn";
                  } else {
                    window.location.href =
                      "https://mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://sp.iccec.cn";
                  }
                })
                .catch(action => {
                  sessionStorage.clear();
                  localStorage.clear();
                  Cookies.remove("access_token");
                  Cookies.remove("refresh_token");
                  // window.location.href =
                  //   this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
                  //   "?redirectUrl=" +
                  //   this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
                  if (this.baseUrl.indexOf("dev01") != -1) {
                    window.location.href =
                      "http://dev01-mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://dev01-sp.iccec.cn";
                  } else if (this.baseUrl.indexOf("test01") != -1) {
                    window.location.href =
                      "http://test01-mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://test01-sp.iccec.cn";
                  } else if (this.baseUrl.indexOf("uat01") != -1) {
                    window.location.href =
                      "https://uat01-mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://uat01-sp.iccec.cn";
                  } else {
                    window.location.href =
                      "https://mla.iccec.cn/apis/mla/users/signup/doLogout?ACCESS_TOKEN=c10c4fbce6dc469987e3385efa508306&redirectUrl=http://sp.iccec.cn";
                  }
                });
            }
            // console.log(res);
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.ccui-app-container {
  min-height: 600px;
}
.ccui-form {
  margin-left: 10%;
}
.ver-code {
  position: relative;
}
.caCode {
  position: absolute;
  top: -10px;
  left: 105%;
  display: flex;
  height: 51px;
  // border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  color: #333;
  margin-bottom: 22px;
  el-input {
    width: 60%;
  }
}
/deep/ .el-form-item__label {
  width: 200px;
}
/deep/ .el-divider {
  background-color: transparent !important;
}
/deep/ .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
  border-top: 1px dashed #ccc !important;
}
/deep/ .ccui-ml-10 {
  position: absolute;
  color: #ff142f;
  line-height: 15px;
}
.wrapper {
  margin-bottom: 20px;
}
.ccui-app-container-detail {
  min-height: calc(100vh - 190px);
  margin: 0px auto 0px !important;
  padding: 15px 0 15px;
  min-width: 1180px;
}
/deep/ .el-form-item__error {
  left: 205px;
}
.red {
  color: #ff142f;
}
.tdu {
  background: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
}
.mb20 {
  margin-bottom: 20px;
}
.uploadTabInlie {
  display: inline-block;
  margin-right: 10px;
}
/deep/ .el-table--border td:first-child .cell::after {
  content: "*";
  color: #ff142f;
}
</style>
